<template>
    <div class="hyde_content_tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="vo.openYt === 1" :label="'会议议程'" name="first"></el-tab-pane>
        <el-tab-pane :label="$tx('hygl.vwMyMeeting.fields.attendName', '全部参会人员')" name="second"></el-tab-pane>
        <el-tab-pane :label="$tx('hygl.hyap.meetSeat', '会议排座')" name="fourth"></el-tab-pane>
        <el-tab-pane :label="$tx('hygl.hyap.meetRecord', '会议笔记')" name="third"></el-tab-pane>
      </el-tabs>
      <div v-loading="loading">
        <div v-if="activeName === 'first'">
          <el-table border :data="tableData" style="margin-bottom: 20px; border-bottom: 1px solid #ebeef5" @row-click="rowClick">
            <el-table-column :label="$tx('fields.index', '序号')" align="center" width="60" type="index" />
            <el-table-column :label="$tx('hygl.components.meetingAgenda', '会议议题')" prop="subject" align="left"></el-table-column>
            <el-table-column :label="$tx('hygl.components.hostDepartment', '主办部门')" prop="mainDept" align="center" width="130" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.declarant', '陈述人')" prop="reportPersonName" width="110" align="center" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.csTime', '陈述时间/分钟')" prop="reportTime" width="150" align="center" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.talkTime', '讨论时间/分钟')" prop="talkTime" width="150" align="center" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.attach', '附件')" prop="remark" align="center" width="70">
              <template slot-scope="scope">
                <span>{{ scope.row.passenger.attachments.length }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$tx('hygl.components.status', '状态')" prop="remark" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ statusFormat(scope.row.status) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="activeName === 'second'">
          <el-table border :data="tableData" style="margin-bottom: 20px; border-bottom: 1px solid #ebeef5">
            <el-table-column :label="$tx('fields.index', '序号')" align="center" width="60" type="index" />
            <el-table-column :label="$tx('fields.name', '姓名')" prop="userName" width="180" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.meetPersonName?scope.row.userName+`（代${scope.row.meetPersonName}）`:scope.row.userName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$tx('hygl.components.duties', '职务')" prop="userPost" align="center" width="130" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.depart', '部门')" prop="userDept" align="left" :show-overflow-tooltip="true" />
            <el-table-column :label="$tx('hygl.components.phone', '电话')" prop="phone" width="130" align="center" :show-overflow-tooltip="true" />
          </el-table>
        </div>
        <div v-if="activeName === 'third'" style="position: relative">
          <div class="btns">
            <el-button class="add_btn" type="primary" icon="el-icon-plus" size="mini" @click="addRecord">填写笔记</el-button>
          </div>
          <el-table border :data="tableData" style="margin-bottom: 20px; border-bottom: 1px solid #ebeef5">
            <el-table-column :label="$tx('fields.index', '序号')" align="center" width="60" type="index"></el-table-column>
            <el-table-column :label="$tx('hygl.hyap.meetRecord', '会议笔记')" prop="content" align="left" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column :label="$tx('pageBtns.operate', '操作')" prop="option" width="100" align="center">
              <template slot-scope="scope">
                <el-link v-pageBtn-lbl="'update'" :underline="false" @click="updateHandle(scope.row, 'edit')">修改</el-link>
                <el-link v-pageBtn-lbl="'del'" :underline="false" @click="updateHandle(scope.row, 'del')">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="activeName === 'fourth'">
          <MeetSeat :meet-id="vo.id" :room-id="vo.meetPlaceId" />
        </div>
      </div>
      <el-dialog v-if="showMeetRecord" v-el-drag-dialog :title="$tx('hygl.hyap.meetRecord', '会议笔记')" :visible.sync="showMeetRecord" :close-on-click-modal="false" width="700px">
        <div>
          <el-input v-model="meetingRecord.content" type="textarea" :rows="7" :placeholder="$tx('hygl.meetingRecords.write', '请填写')" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="showMeetRecord = false">关 闭</el-button>
          <el-button v-pageBtn-lbl="'save'" icon="el-icon-check" type="primary" @click="changeMeetRecord">保 存</el-button>
        </span>
      </el-dialog>
      <Basicform :title="$tx('hygl.components.meetingAgenda', '会议议题')" :win-width="moduleInfo1.winWidth" :win-height="moduleInfo1.winHeight" :append-to-body="true" :toolbar-btns="busiformBtns">
        <template #default="slotProps">
          <busi-form ref="hyyt" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo1" />
        </template>
      </Basicform>
    </div>
  </template>

<script>
const moment = require('moment')
import MeetSeat from './components/meetSeat'
export default {
    components: {
        MeetSeat
    },
    props: {
        vo: {
            type: Object,
            default: function() {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        moduleInfo: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            loading: false,
            loginUser: this.$store.getters.loginUser,
            activeName: 'first',
            tableData: [],
            tableDataPeople: [],
            meetingRecord: {}, // 会议记录对象
            showMeetRecord: false, // 打开会议记录弹窗
            updateType: 'add', // 判断会议记录是新增还是修改   add (新增) edit (修改)
            moduleInfo1: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                winWidth: 1200,
                delUrl: '/hygl/ytRecord/delete',
                addNewUrl: '/hygl/ytRecord/addNew',
                insertUrl: '/hygl/ytRecord/insert',
                moduleCode: 'budgetKpi',
                winHeight: 600,
                updateUrl: '/hygl/ytRecord/update',
                listDataUrl: '/hygl/ytRecord/listdata',
                getByIdUrl: '/hygl/ytRecord/getById'
            },
            busiformBtns: []
        }
    },
    created() {
        if (this.vo.openYt !== 1) this.activeName = 'second'
        this.getTableData()
    },
    methods: {
        handleClick(tab, event) {
            this.loading = true
            this.getTableData()
        },
        getTableData() {
            var params = {}
            var url = ''

            if (this.activeName === 'first') {
                url = 'hygl/ytRecord/listdata'
                params.urlsearch = `hyapId:${this.vo.id}`

                this.tableData = this.vo.passenger.hyapYtInfoList
                this.loading = false
                return
            } else if (this.activeName === 'second') {
                url = 'hygl/meetPeople/listdata'
                params.urlsearch = `meetId:${this.vo.id};meetPersonType!:4`
            } else if (this.activeName === 'third') {
                url = 'hygl/meetingRecord/listdata'
                params.urlsearch = `meetingId:${this.vo.id}`
            } else if (this.activeName === 'fourth') {
                this.loading = false
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: url,
                method: 'POST',
                params
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableData = res.body.pageInfo.list
                }
                this.loading = false
            })
        },
        rowClick(row, column, event) {
            if (this.activeName !== 'first') return
            var _this = this
            _this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                }
            ]
            _this.moduleInfo1.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo1.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo1, row, 0, (res) => {
                    _this.busiformBtns = []
                })
            })
        },
        // 填写记录
        addRecord() {
            this.updateType = 'add'
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/meetingRecord/addNew',
                method: 'POST'
            }).then((res) => {
                if (res.code === 'success') {
                    // this.tableData = res.body.pageInfo.list
                    this.meetingRecord = res.body.vo
                    this.meetingRecord.meetingId = this.vo.id
                    this.meetingRecord.createTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                    this.meetingRecord.creator = this.loginUser.personName
                    this.showMeetRecord = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 会议记录修改、插入
        changeMeetRecord() {
            if (!this.meetingRecord.content) {
                this.$message.warning(this.$tx('hygl.message.fixHyRecords', '请填写会议笔记'))
                return
            }
            var url = 'hygl/meetingRecord/insert'
            var type = 'POST'
            if (this.updateType === 'edit') {
                type = 'PUT'
                url = 'hygl/meetingRecord/update'
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: url,
                method: type,
                data: this.meetingRecord
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.showMeetRecord = false
                    this.getTableData()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 会议记录修改
        updateHandle(row, type) {
            if (type === 'edit') {
                this.updateType = 'edit'
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: 'hygl/meetingRecord/getById',
                    method: 'GET',
                    params: {
                        id: row.id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.meetingRecord = res.body.vo
                        this.showMeetRecord = true
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.$confirm(this.$tx('hygl.message.delRecord', '是否确认删除此会议笔记？'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    cancelButtonText: this.$tx('pageBtns.cancel', '取消'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http({
                            contentType: 'application/x-www-form-urlencoded',
                            url: 'hygl/meetingRecord/delete',
                            method: 'DELETE',
                            params: {
                                ids: row.id
                            }
                        }).then((res) => {
                            if (res.code === 'success') {
                                this.showMeetRecord = false
                                this.$message({ type: 'success', message: res.message })
                                this.getTableData()
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    })
                    .catch(() => {
                        // do nothing
                    })
            }
        },
        statusFormat(val) {
            var str = ''
            switch (val) {
                case 0:
                    str = this.$tx('hygl.tableColumn.noAttend', '未上会')
                    break
                case 1:
                    str = this.$tx('hygl.tableColumn.doneAttend', '已上会')
                    break
                case 2:
                    str = this.$tx('hygl.tableColumn.todoAttend', '待上会')
                    break
                case 3:
                    str = this.$tx('hygl.tableColumn.cancelAttend', '已取消')
                    break
                default:
                    str = ''
                    break
            }
            return str
        }
    }
}
</script>

  <style lang="scss">
  .hyde_content_tab .el-tabs__nav-wrap::after {
      display: none !important;
  }
  </style>
  <style lang="scss" scoped>
  .hyde_content_tab .btns {
      position: absolute;
      top: -45px;
      right: 0;
  }
  </style>
